{
  "computed": {},
  "localState": {},
  "props": {}
}
